import { AssessmentResult } from '../../types/assessment';
import TiCard from '../common/TiCard';

interface Props {
  result: AssessmentResult;
}

export default function FindingsCard({ result }: Props) {
  return (
    <TiCard label="Key findings" animate fullHeight>
      {result.findings.map((f, i) => (
        <div key={i} className="finding-item">
          <div className={`finding-dot dot-${f.color}`} />
          <div className="finding-text">
            <strong>{f.title}</strong> {f.body}
          </div>
        </div>
      ))}
    </TiCard>
  );
}
